// extracted by mini-css-extract-plugin
export default {"dayIcon":"day-icon_dayIcon__psTAX"};